import { render, staticRenderFns } from "./AppIconTooltipAndText.vue?vue&type=template&id=62bf61a6"
import script from "./AppIconTooltipAndText.vue?vue&type=script&lang=js"
export * from "./AppIconTooltipAndText.vue?vue&type=script&lang=js"
import style0 from "./AppIconTooltipAndText.vue?vue&type=style&index=0&id=62bf61a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports